import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OperationsService } from '../../../../core/services/operations.service';
import { Classificazione } from '../../../models/classificazione';
import { DescrittoreSezione } from '../../../models/descrittore-sezione';
import { ClassificazioneSezione } from '../../../models/sezioni/classificazione-sezione';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
    selector: '[classificazione-pratica]',
  templateUrl: 'classificazione-pratica.component.html'
})

export class ClassificazionePraticaComponent {

  @Input() descrittore: DescrittoreSezione;
  @Input() pratica;
  @Input() sezione: ClassificazioneSezione;
  @Input() deleteClassificazioneUrl: string;
  @Input() setClassificazionePrincipaleUrl: string;
  @Output() onReturnClassificazione: EventEmitter<Classificazione> = new EventEmitter<Classificazione>();
  @Output() onReturnSezione: EventEmitter<ClassificazioneSezione> = new EventEmitter<ClassificazioneSezione>();
  constructor(private operationService: OperationsService, private helpers: HelpersService) {}

  removeClassificazione(idClassificazione: string) {
    this.operationService.removeClassificazioneFromSezOrdinario(this.deleteClassificazioneUrl, this.sezione.id, idClassificazione)
      .subscribe(response => this.onReturnSezione.emit(response.sezione));
  }

  changeClassificazione(classificazione: Classificazione) {
    this.onReturnClassificazione.emit(classificazione);
  }

  setClassificazionePrincipale(classificazione: Classificazione) {
    this.operationService.setClassificazionePrincipale(this.setClassificazionePrincipaleUrl, this.sezione.id, classificazione.id)
      .subscribe(response => {
        const index = response.sezione.classificazioni.findIndex(x => x.isPrincipale === true);
        this.helpers.updatePratica(
          this.pratica.id,
          response.sezione.classificazioni[index].materia.descrizione,
          response.sezione.classificazioni[index].oggetto.descrizione
        );
        this.onReturnSezione.emit(response.sezione);
      });
  }
}
